module.exports = __webpack_public_path__ + "img/apple-icon-60x60.bd0f27d.png";